'use client';

import { AlertTriangleIcon } from '@/components/icons';
import { LegalPageLayout } from '@/components/legal/legal-page-layout';

const allergens = [
  'Арахис и продукты его переработки',
  'Аспартам и аспартам-ацесульфама соль',
  'Горчица и продукты её переработки',
  'Диоксид серы и сульфиты (более 10 мг/кг или 10 мг/л в пересчёте на диоксид серы)',
  'Злаки, содержащие глютен, и продукты их переработки',
  'Кунжут и продукты его переработки',
  'Люпин и продукты его переработки',
  'Моллюски и продукты их переработки',
  'Молоко и продукты его переработки (в том числе лактоза)',
  'Орехи и продукты их переработки',
  'Ракообразные и продукты их переработки',
  'Рыба и продукты её переработки (кроме рыбного желатина в витаминных препаратах)',
  'Сельдерей и продукты его переработки',
  'Соя и продукты её переработки',
  'Яйца и продукты их переработки',
];

const BulletList = ({ items }: { items: string[] }) => (
  <ul className="space-y-2 pl-1">
    {items.map((item, i) => (
      <li key={i} className="flex items-start gap-2">
        <span className="mt-1.5 w-1.5 h-1.5 rounded-pill bg-amber-500 flex-shrink-0" />
        <span>{item}</span>
      </li>
    ))}
  </ul>
);

export function AllergensContent() {
  const sections = [
    {
      title: 'Нормативная база',
      content: (
        <div className="p-4 rounded-card bg-amber-500/10 border border-amber-500/20">
          <p className="font-medium text-[var(--text-primary)] mb-1">
            Согласно Техническому регламенту Таможенного союза
          </p>
          <p>
            ТР ТС 022/2011 «Пищевая продукция в части её маркировки» (ч.4.4, п.14), вступившему в силу с 01.07.2013 г.
          </p>
        </div>
      ),
    },
    {
      title: 'Список аллергенов',
      content: (
        <>
          <p className="mb-3">
            К наиболее распространённым компонентам, употребление которых может вызвать аллергические реакции или противопоказано при отдельных видах заболеваний, относятся:
          </p>
          <BulletList items={allergens} />
        </>
      ),
    },
    {
      title: 'Важная информация',
      content: (
        <p>
          Если у вас есть аллергия или пищевая непереносимость, пожалуйста, сообщите об этом оператору при оформлении заказа. Мы постараемся учесть ваши пожелания и подобрать безопасные блюда.
        </p>
      ),
    },
  ];

  return (
    <LegalPageLayout
      title="Аллергены"
      icon={<AlertTriangleIcon className="w-3.5 h-3.5 text-[var(--primary)]" weight="fill" />}
      sections={sections}
      breadcrumbs={[
        { name: 'Главная', href: '/' },
        { name: 'Аллергены', href: '/allergens' },
      ]}
      contactBlock={
        <div className="text-sm text-[var(--text-secondary)]">
          <p>Вопросы по составу продукции:</p>
          <a href="tel:+78633335050" className="text-[var(--primary)] font-medium hover:underline">
            +7 (863) 333-50-50
          </a>
        </div>
      }
    />
  );
}
